import axios from "axios";

export default {
  name: "reconciliation",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getbankguaranteelist(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_garansi/data_input",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createBankGuarantee(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_garansi",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cancelBankGuarantee(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_garansi/cancel",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nonActiveBankGuarantee(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "bank_garansi/non_active",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDataBankGuarantee(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_garansi",
          data: {},
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
